<template>
  <div id="app" :data-page="$pageName">
    <NavigationMenu :content="navigation">
      <template v-slot:left>
        <router-link class="logo-text underline" to="/"
          >Wolstanton Conservative Club</router-link
        >
      </template>
    </NavigationMenu>
    <router-view />

    

    <Section wrap class="pad2 footer">
      <Grid middle no-grow>
        <Column :below-laptop-width="100" below-laptop-text-center  fill center>
          <div>
            <a href="https://goo.gl/maps/cZpT2Tr81XdS4AKY8" target="_blank" >
              <p>
                <b><u>Registered Address</u></b> <br>  
                2-4 Lily St,<br>  
                Wolstanton,<br>  
                Newcastle-under-Lyme,<br>  
                ST5 0BE. 
              </p>
            </a>
          </div>
        </Column>
        <Column fill center :below-laptop-width="100">
        <div>
          <p>
            <b><u>Contact Details</u></b> <br>
          </p>
          <div class="center-vertical center-horizontally">                          
            <div class="contact">
              <span><em>Phone: </em> <a href="tel:+441782616863">Call Us</a></span>
            </div>
          </div>
          <div class="center-vertical center-horizontally">
            <div class="contact">
              <span><em>Email: </em> <a href="mailto:thesecretary@wolstantoncon.plus.com">The Secretary</a></span>
            </div>
          </div>
          <div class="center-vertical center-horizontally">
            <div class="contact">
              <a href="./documents/WolstantonConservativeClub PrivacyNotice.pdf" target="_blank">Privacy Policy</a>
            </div>
          </div>          
        </div>
        </Column>
        <!-- <Column :below-laptop-width="100" below-laptop-text-center  fill center>
          <div>
            <a href="https://goo.gl/maps/XnwVUwpfni2MjCn17" target="_blank">
              <p>
                <b><u>Association Head Office</u></b> <br>                
                The Association Of<br>  
                Conservative Clubs Ltd.<br>  
                24 Old Queens Street,<br>  
                London,<br>  
                SW1H 9HP. 
              </p>
            </a>
          </div>
        </Column> -->
      </Grid>      
    </Section>

    <Section wrap class="pad2 footer">
      <Grid middle no-grow>
        <Column>
        </Column>
        <Column fill center :below-laptop-width="100">
          <div class="center-vertical center-horizontally">
            <a href="https://cyberkiln.com/" target="_blank">
                Crafted by
                <br />
                <img
                  class="cyberkiln"
                  src="/images/cyberkiln.svg"
                />
              </a>
          </div>
        </Column>
        <Column :below-laptop-width="100" below-laptop-text-center>
        </Column>
      </Grid>
    </Section>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      navigation: {
        links: [
          { name: "Entertainment", url: "/entertainment" },
          { name: "Room Hire", url: "/roomhire" },
          { name: "Committee", url: "/committee" },
          { name: "History", url: "/history" },
          { name: "Gallery", url: "/gallery" },          
          { name: "Contact", url: "/contact" }
        ]
      }
    };
  },
  mounted: function() {}
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Baskervville&display=swap");
#app {
  font-family: 'Baskervville', serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app,
.navigation-menu {
  // Don't go less than 320px otherwise top menu is a mess
  min-width: 320px;
}

.logo-text,
.footer-logo {
  font-family: "Baskervville", serif;
  font-size: 1.4em;
}
.logo-text {
  margin-right: 1em;

  // Match navigation colors
  color: var(--color-nav-menu-link);
  &:hover {
    // Same color on hover
    color: var(--color-nav-menu-link-hover);
  }

  @include media($breakpoint-below-laptop) {
    font-size: 4vw;
    margin-right: 0.2em;
    padding-left: 1em;
  }

  @include media($breakpoint-below-tablet) {
    font-size: 5vw;
    margin-right: 0.2em;
    padding-left: 1em;
  }
}

.reduced .logo-text,
.expanded .logo-text {
  // Match navigation colors
  color: var(--color-nav-menu-link-scrolled);
  &:hover {
    // Same color on hover
    color: var(--color-nav-menu-link-scrolled-hover);
  }
}

a.underline {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 0.08em;
    bottom: 0;
    left: 0;
    background-color: var(--color-primary);
    transform: scaleX(0);
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before {
    transform: scaleX(1);    
  }
}

.cyberkiln {
  @media only screen and (min-width: 320px) and (max-width: 480px) {
    width: 35vw; 
    padding-top: 10px;
  }
  @media only screen and (min-width: 481px) and (max-width: 768px) {
    width: 35vw;
  }  
  @media only screen and (min-width: 769px) and (max-width: 1024px) {
    width: 20vw;
  }
  @media only screen and (min-width: 1025px) and (max-width: 1200px) {
    width: 15vw;
  }
  @media only screen and (min-width: 1201px) {
    width: 15vw;
  }
}

.footer {
  background-color: var(--color-dark-background);

  color: var(--color-foreground-lighter);

  a {
    color: var(--color-dark-background-text) !important;

    &:hover {
      color: var(--color-primary) !important;
    }
  }

  p {
    margin: 0;
    display: inline-block;
    font-family: auto;
  }

  .footer-logo {
    color: var(--color-link);

    margin-bottom: 1em;

    img {
      height: 2em;
      display: inline-block;
    }
  }

  .social {
    @include media($breakpoint-below-laptop) {
      padding-top: 1em;
    }

    a {
      display: inline-block;
      transition: transform ease-in-out 0.3s;
      transform-origin: center center;

      margin-left: 1em;

      @include media($breakpoint-below-laptop) {
        margin-left: 0;
      }

      img {
        width: 2em;
      }

      &:hover {
        transform: scale(1.3);
      }
    }
  }

  .contact {
    text-align: center;

    span {
      display: inline-block;
    }

    span:not(:first-child) {
      @extend .pl;
    }
  }
}
</style>
